import { render, staticRenderFns } from "./guess.vue?vue&type=template&id=df12a17e&scoped=true"
import script from "./guess.vue?vue&type=script&lang=js"
export * from "./guess.vue?vue&type=script&lang=js"
import style0 from "./guess.vue?vue&type=style&index=0&id=df12a17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df12a17e",
  null
  
)

export default component.exports